<div
	*ngIf="image as currentImage"
	#lightboxDialog
	class="image-lightbox"
	role="dialog"
	aria-modal="true"
	[attr.aria-label]="'Expanded image: ' + currentImage.alt"
	cdkTrapFocus
	[cdkTrapFocusAutoCapture]="true"
	(click)="onBackdropClick($event)"
>
	<div class="image-lightbox__controls">
		<button
			type="button"
			class="image-lightbox__close"
			aria-label="Close expanded image"
			(click)="close()"
		>
			<span aria-hidden="true">&times;</span>
		</button>

		<button
			*ngIf="fullscreenSupported"
			type="button"
			class="image-lightbox__fullscreen"
			[attr.aria-label]="isFullscreen ? 'Exit browser fullscreen' : 'View image in browser fullscreen'"
			(click)="toggleFullscreen()"
		>
			{{ isFullscreen ? "Exit fullscreen" : "Fullscreen" }}
		</button>
	</div>

	<figure class="image-lightbox__figure">
		<img [src]="currentImage.src" [alt]="currentImage.alt" />
		<figcaption *ngIf="currentImage.caption">
			{{ currentImage.caption }}
		</figcaption>
	</figure>
</div>
